import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const ExtendedPrice = (props) => {
  const { item, isQuantityUpdating } = props;

  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { currency } = settings;
  return (
    <div
      className={classNames(
        'c7-order-item__total',
        isQuantityUpdating && 'c7-loading--overlay'
      )}
    >
      {isQuantityUpdating && (
        <div className="c7-spinner" role="status" aria-live="polite">
          <span className="c7-sr-only">
            {t('general.accessibility.loading')}
          </span>
        </div>
      )}
      <span>
        <span className="c7-sr-only">Total Price</span>
        {currencyFormat(item.price * item.quantity, currency)}
      </span>
    </div>
  );
};

export default ExtendedPrice;
